import { render, staticRenderFns } from "./teammember_info.vue?vue&type=template&id=9013a5a6&scoped=true&"
import script from "./teammember_info.vue?vue&type=script&lang=js&"
export * from "./teammember_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9013a5a6",
  null
  
)

export default component.exports